<div class="container navbar-class fixed-top">
  <app-nav-user></app-nav-user>
</div>

<div class="navigation-header" id="proposal">
  <h1>{{'newOrder.title' | translate}}</h1>
</div>

<section id="trial-lens">
  <mat-accordion>

    <mat-expansion-panel (opened)="panelProposalOpenState = true" (closed)="panelProposalOpenState = false"
                         [expanded]="panelProposalOpenState" style="margin-top:10px;">
      <mat-expansion-panel-header>
        <mat-panel-title style="margin-top: 15px;">
          <h1> {{'newOrder.hechtProposal.title' | translate }}</h1>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-new-order-proposal #proposal (copyEmit)="copyProposal($event)" (switchEmit)="switch($event)"
                              (rotateEmit)="rotateProposal($event)"></app-new-order-proposal>
    </mat-expansion-panel>

  </mat-accordion>
</section>
<section id="final-lens">
  <mat-accordion>

    <mat-expansion-panel (opened)="panelTrialLensOpenState = true" (closed)="panelTrialLensOpenState = false"
                         [expanded]="panelTrialLensOpenState" style="margin-top:10px;">
      <mat-expansion-panel-header>
        <mat-panel-title style="margin-top: 15px;">
          <h1>{{'newOrder.trialLens.title' | translate }}</h1>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-new-order-trial-lens-with-overrefraction #trialLens (copyEmit)="copyTrialLens($event)"
                                                    (switchEmit)="switch($event)"
                                                    (rotateEmit)="rotateTrialLens($event)"></app-new-order-trial-lens-with-overrefraction>
    </mat-expansion-panel>

  </mat-accordion>
</section>
<section id="care">
  <mat-accordion>

    <mat-expansion-panel (opened)="panelFinalLensOpenState = true" (closed)="panelFinalLensOpenState = false"
                         [expanded]="panelFinalLensOpenState" style="margin-top:10px;">
      <mat-expansion-panel-header>
        <mat-panel-title style="margin-top: 15px;">
          <h1>{{'newOrder.navigation.finalLens' | translate }}</h1>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-new-order-final-lens #finalLens (copyEmit)="copyFinalLens($event)" (switchEmit)="switch($event)"
                                (rotateEmit)="rotateFinalLens($event)"></app-new-order-final-lens>
    </mat-expansion-panel>

  </mat-accordion>
</section>
<section id="accessories">
  <mat-accordion>

    <mat-expansion-panel (opened)="panelCareOpenState = true" (closed)="panelCareOpenState = false"
                         [expanded]="panelCareOpenState" style="margin-top:10px;">
      <mat-expansion-panel-header>
        <mat-panel-title style="margin-top: 15px;">
          <h1>{{"newOrder.equipment.care.title" | translate}}</h1>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-care [ordering]="true"></app-care>
    </mat-expansion-panel>

  </mat-accordion>
</section>
<section id="order-confirm">
  <mat-accordion>

    <mat-expansion-panel (opened)="panelAccessoriesOpenState = true" (closed)="panelAccessoriesOpenState = false"
                         [expanded]="panelAccessoriesOpenState" style="margin-top:10px;">
      <mat-expansion-panel-header>
        <mat-panel-title style="margin-top: 15px;">
          <h1>{{"newOrder.equipment.accessories.title" | translate}}</h1>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-accessories [ordering]="true"></app-accessories>
    </mat-expansion-panel>

  </mat-accordion>
</section>
<section>
  <mat-accordion>

    <mat-expansion-panel (opened)="panelConfirmOpenState = true" (closed)="panelConfirmOpenState = false"
                         [expanded]="panelConfirmOpenState" style="margin-top:10px;">
      <mat-expansion-panel-header>
        <mat-panel-title style="margin-top: 15px;">
          <h1>{{"newOrder.confirm.title" | translate}}</h1>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-new-order-confirm></app-new-order-confirm>
    </mat-expansion-panel>

  </mat-accordion>
</section>
